/**
 * Copyright (C) 2025 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import ActionCreator from '../action-creator';

export const ActionCreators = {
  // Ground Station Coverage Actions (used by requestCoverageEpic)
  RequestGroundStationCoverage: new ActionCreator<'RequestGroundStationCoverage', any>('RequestGroundStationCoverage'),
  ReceivedGroundStationCoverageSuccess: new ActionCreator<'ReceivedGroundStationCoverageSuccess', any>(
    'ReceivedGroundStationCoverageSuccess',
  ),
  ReceivedGroundStationCoverageError: new ActionCreator<'ReceivedGroundStationCoverageError', any>(
    'ReceivedGroundStationCoverageError',
  ),
};

export type Action = typeof ActionCreators[keyof typeof ActionCreators];

export function requestGroundStationCoverage() {
  return (dispatch: any) => {
    dispatch(ActionCreators.RequestGroundStationCoverage.create());
  };
}